import { TimelineModel } from '../../shared/models/timeline.model';

export const ForgetPasscodeTimelines: TimelineModel[] = [
    {
        title: 'Verify OTP',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { otp: '', validationKey: '' },
    },
    {
        title: 'Enter Passcode',
        description: 'Enter your 6 digit passcode',
        step: 3,
        previousTitle: 'Password Recovery',
        state: 'inactive',
        isFinalStep: true,
        mobileNote: 'STEP 3',
        data: { passcode: '' },
    },
    {
        title: 'Confirm Passcode',
        description: 'Re-enter Passcode',
        step: 4,
        disabled: true,
        previousTitle: 'Enter Passcode',
        state: 'inactive',
        mobileNote: 'STEP 4',
        data: { confirmPasscode: '' },
    },
];

export const ForgetPasscodeTimelines2FAOrderByOTP: TimelineModel[] = [
    {
        title: 'Verify OTP',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { otp: '', validationKey: '' },
    },
    {
        title: 'Verify ID Information',
        description: '',
        step: 3,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 3',
        data: { reference: '' },
    },
    {
        title: 'Enter Passcode',
        description: 'Enter your 6 digit passcode',
        step: 4,
        previousTitle: 'Password Recovery',
        state: 'inactive',
        isFinalStep: true,
        mobileNote: 'STEP 4',
        data: { passcode: '' },
    },
    {
        title: 'Confirm Passcode',
        description: 'Re-enter Passcode',
        step: 5,
        disabled: true,
        previousTitle: 'Enter Passcode',
        state: 'inactive',
        mobileNote: 'STEP 5',
        data: { confirmPasscode: '' },
    },
];

export const ForgetPasscodeTimelines2FAOrderByLiveliness: TimelineModel[] = [
    {
        title: 'Verify ID Information',
        description: '',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { reference: '' },
    },
    {
        title: 'Verify OTP',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 3,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 3',
        data: { otp: '', validationKey: '' },
    },
    {
        title: 'Enter Passcode',
        description: 'Enter your 6 digit passcode',
        step: 4,
        previousTitle: 'Password Recovery',
        state: 'inactive',
        isFinalStep: true,
        mobileNote: 'STEP 4',
        data: { passcode: '' },
    },
    {
        title: 'Confirm Passcode',
        description: 'Re-enter Passcode',
        step: 5,
        disabled: true,
        previousTitle: 'Enter Passcode',
        state: 'inactive',
        mobileNote: 'STEP 5',
        data: { confirmPasscode: '' },
    },
];

export const ForgetPasswordTimelines: TimelineModel[] = [
    {
        title: 'Verify OTP',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { otp: '', validationKey: '' },
    },
    {
        title: 'Change Password',
        description: 'Enter a new password to reset your password',
        step: 3,
        previousTitle: 'Password Recovery',
        state: 'inactive',
        mobileNote: 'STEP 3',
        isFinalStep: true,
        data: { password: '' },
    },
    {
        title: 'Confirm Password',
        description: 'Re-enter Password',
        step: 4,
        disabled: true,
        previousTitle: 'Enter Password',
        state: 'inactive',
        mobileNote: 'STEP 4',
        data: { confirmPassword: '' },
    },
];

export const ForgetPasswordTimelines2FAOrderByOTP: TimelineModel[] = [
    {
        title: 'Verify OTP',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { otp: '', validationKey: '' },
    },
    {
        title: 'Verify ID Information',
        description: '',
        step: 3,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 3',
        data: { reference: '' },
    },
    {
        title: 'Change Password',
        description: 'Enter a new password to reset your password',
        step: 4,
        previousTitle: 'Password Recovery',
        state: 'inactive',
        mobileNote: 'STEP 4',
        isFinalStep: true,
        data: { password: '' },
    },
    {
        title: 'Confirm Password',
        description: 'Re-enter Password',
        step: 5,
        disabled: true,
        previousTitle: 'Enter Password',
        state: 'inactive',
        mobileNote: 'STEP 5',
        data: { confirmPassword: '' },
    },
];

export const ForgetPasswordTimelines2FAOrderByLiveliness: TimelineModel[] = [
    {
        title: 'Verify ID Information',
        description: '',
        step: 2,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 2',
        data: { reference: '' },
    },
    {
        title: 'Verify OTP',
        description: 'We’ve just sent you a 6 digit code to your registered phone number. Check your messages and enter it here.',
        step: 3,
        state: 'inactive',
        previousTitle: 'Password Recovery',
        mobileNote: 'STEP 3',
        data: { otp: '', validationKey: '' },
    },
    {
        title: 'Change Password',
        description: 'Enter a new password to reset your password',
        step: 4,
        previousTitle: 'Password Recovery',
        state: 'inactive',
        mobileNote: 'STEP 4',
        isFinalStep: true,
        data: { password: '' },
    },
    {
        title: 'Confirm Password',
        description: 'Re-enter Password',
        step: 5,
        disabled: true,
        previousTitle: 'Enter Password',
        state: 'inactive',
        mobileNote: 'STEP 5',
        data: { confirmPassword: '' },
    },
];

export const PhoneForgetPasscodeTimeline: TimelineModel[] = [
    {
        title: 'Confirm Phone number',
        description: 'Confirm Phone number',
        step: 1,
        previousTitle: 'Passcode Recovery',
        state: 'active',
        mobileNote: 'STEP 1',
        data: { phoneNumber: '' },
    },
];

export const PhoneForgetPasswordTimeline: TimelineModel[] = [
    {
        title: 'Confirm Phone number',
        description: 'Confirm Phone number',
        step: 1,
        previousTitle: 'Password Recovery',
        state: 'active',
        mobileNote: 'STEP 1',
        data: { phoneNumber: '' },
    },
];

export const UsernameForgetPasscodeTimeline: TimelineModel[] = [
    {
        title: 'Confirm Username',
        description: 'Confirm Username',
        step: 1,
        previousTitle: 'Passcode Recovery',
        state: 'active',
        mobileNote: 'STEP 1',
        data: { username: '' },
    },
];

export const UsernameForgetPasswordTimeline: TimelineModel[] = [
    {
        title: 'Confirm Username',
        description: 'Confirm Username',
        step: 1,
        previousTitle: 'Password Recovery',
        state: 'active',
        mobileNote: 'STEP 1',
        data: { username: '' },
    },
];

export const ForgetPasscodeTimelinesViaPhonenumber: TimelineModel[] = [...PhoneForgetPasscodeTimeline, ...ForgetPasscodeTimelines];
export const ForgetPasscodeTimelinesViaPhonenumber2FAOrderByOTP: TimelineModel[] = [
    ...PhoneForgetPasscodeTimeline,
    ...ForgetPasscodeTimelines2FAOrderByOTP,
];
export const ForgetPasscodeTimelinesViaPhonenumber2FAOrderByLiveliness: TimelineModel[] = [
    ...PhoneForgetPasscodeTimeline,
    ...ForgetPasscodeTimelines2FAOrderByLiveliness,
];

export const ForgetPasswordTimelinesViaPhonenumber: TimelineModel[] = [...PhoneForgetPasswordTimeline, ...ForgetPasswordTimelines];
export const ForgetPasswordTimelinesViaPhonenumber2FAOrderByOTP: TimelineModel[] = [
    ...PhoneForgetPasswordTimeline,
    ...ForgetPasswordTimelines2FAOrderByOTP,
];
export const ForgetPasswordTimelinesViaPhonenumber2FAOrderByLiveliness: TimelineModel[] = [
    ...PhoneForgetPasswordTimeline,
    ...ForgetPasswordTimelines2FAOrderByLiveliness,
];

export const ForgetPasscodeTimelinesViaUsername: TimelineModel[] = [...UsernameForgetPasscodeTimeline, ...ForgetPasscodeTimelines];
export const ForgetPasscodeTimelinesViaUsername2FAOrderByOTP: TimelineModel[] = [
    ...UsernameForgetPasscodeTimeline,
    ...ForgetPasscodeTimelines2FAOrderByOTP,
];
export const ForgetPasscodeTimelinesViaUsername2FAOrderByLiveliness: TimelineModel[] = [
    ...UsernameForgetPasscodeTimeline,
    ...ForgetPasscodeTimelines2FAOrderByLiveliness,
];

export const ForgetPasswordTimelinesViaUsername: TimelineModel[] = [...UsernameForgetPasswordTimeline, ...ForgetPasswordTimelines];
export const ForgetPasswordTimelinesViaUsername2FAOrderByOTP: TimelineModel[] = [
    ...UsernameForgetPasswordTimeline,
    ...ForgetPasswordTimelines2FAOrderByOTP,
];
export const ForgetPasswordTimelinesViaUsername2FAOrderByLiveliness: TimelineModel[] = [
    ...UsernameForgetPasswordTimeline,
    ...ForgetPasswordTimelines2FAOrderByLiveliness,
];

export enum PasscodeRecoveryStep {
    ENTER_PASSCODE_RECOVERY = 1,
    PHONE_VERIFICATION,
    ENTER_PASSCODE,
    CONFIRM_PASSCODE,
    PASSCODE_UPDATED,
}

export enum PasscodeRecoveryStep2FAOrderByOTP {
    ENTER_PASSCODE_RECOVERY = 1,
    PHONE_VERIFICATION,
    LIVELINESS,
    ENTER_PASSCODE,
    CONFIRM_PASSCODE,
    PASSCODE_UPDATED,
}

export enum PasscodeRecoveryStep2FAOrderByLiveliness {
    ENTER_PASSCODE_RECOVERY = 1,
    LIVELINESS,
    PHONE_VERIFICATION,
    ENTER_PASSCODE,
    CONFIRM_PASSCODE,
    PASSCODE_UPDATED,
}

export enum PasswordRecoveryStep {
    ENTER_PASSWORD_RECOVERY = 1,
    PHONE_VERIFICATION,
    ENTER_PASSWORD,
    CONFIRM_PASSWORD,
    PASSWORD_UPDATED,
}

export enum PasswordRecoveryStep2FAOrderByOTP {
    ENTER_PASSWORD_RECOVERY = 1,
    PHONE_VERIFICATION,
    LIVELINESS,
    ENTER_PASSWORD,
    CONFIRM_PASSWORD,
    PASSWORD_UPDATED,
}

export enum PasswordRecoveryStep2FAOrderByLiveliness {
    ENTER_PASSWORD_RECOVERY = 1,
    LIVELINESS,
    PHONE_VERIFICATION,
    ENTER_PASSWORD,
    CONFIRM_PASSWORD,
    PASSWORD_UPDATED,
}

export enum LoginTypeRequest {
    PHONENUMBER = 'PHONENUMBER',
    USERNAME = 'USERNAME ',
}
